
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jouXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ad23539db906c2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $88TYL = parcelRequire("88TYL");
class $73ad23539db906c2$export$2e2bcd8739ae039 extends (0, $gwFzn.PureComponent) {
    render() {
        const { children: children } = this.props;
        if ((0, $gwFzn.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $88TYL.default), {
            children: children
        });
    }
}

});
parcelRegister("88TYL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b95db5ab63622e0a$export$2e2bcd8739ae039);
/* DecisionList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");
const $b95db5ab63622e0a$var$listStyles = null;
class $b95db5ab63622e0a$export$2e2bcd8739ae039 extends (0, $gwFzn.PureComponent) {
    render() {
        const { children: children } = this.props;
        if (!children) return null;
         // Data attributes are required for copy and paste from rendered content
        // to the editor to preserve the decision.
        // This allows the editor to differentiate between numbered and ordered lists,
        // and action items, which all share the common `<li>` element.
        // The value of `data-decision-local-id` should be discarded upon paste, with a
        // a new uuid generated by the editor for the cloned content.
        return /*#__PURE__*/ (0, $7UHDa.jsx)("ol", {
            "data-decision-list-local-id": "",
            "data-node-type": "decisionList",
            className: (0, $35pXk.default)([
                "_1braglyw _1yxxidpf"
            ]),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(children, (child, idx)=>{
                const { localId: localId } = child.props;
                return /*#__PURE__*/ (0, $7UHDa.jsx)("li", {
                    "data-decision-local-id": localId || '',
                    "data-decision-state": "DECIDED",
                    children: child
                }, idx);
            })
        });
    }
}

});



//# sourceMappingURL=decisionList.dd204f4f.js.map
